import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5089ee20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "/", -1))

import IconButton from '@/components/molecules/IconButton.vue'
import { computed, withDefaults } from 'vue'

type PropsType = {
  total?: number | null
  currentPage?: number
  pageSize?: number
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimplePagination',
  props: {
    total: { default: null },
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["pageChange"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'pageChange', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { total: number | null, currentPage: number, pageSize: number, disabled: boolean };





const maxPage = computed<number>(() => (props.total ? Math.ceil(props.total / props.pageSize) : 0))

const disabledPrevBtn = computed<boolean>(() => props.currentPage === 1 || props.disabled)

const disabledNextBtn = computed<boolean>(
  () => props.currentPage === maxPage.value || props.disabled
)

const displayRange = computed<string>(() => {
  const startNum = (props.currentPage - 1) * props.pageSize
  const displayStartNum = startNum + 1
  let displayEndNum = startNum + props.pageSize

  if (props.total && startNum + props.pageSize > props.total) {
    displayEndNum = props.total
  }

  return `${displayStartNum} 〜 ${displayEndNum}`
})

const displayPagination = computed<boolean>(() => maxPage.value > 1)

const handleCurrentChange = (dir: string) => {
  let page = props.currentPage
  if (dir === 'next') {
    page++
  } else {
    page--
  }
  emit('pageChange', page)
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, [
      _createTextVNode(_toDisplayString(_unref(displayRange)), 1),
      _hoisted_2,
      _createTextVNode(_toDisplayString(__props.total), 1)
    ]),
    _createVNode(IconButton, {
      class: "icon-button",
      icon: "keyboard_arrow_left",
      iconColor: "color-dark2",
      useBorder: false,
      disabled: _unref(disabledPrevBtn),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCurrentChange('prev')))
    }, null, 8, ["disabled"]),
    _createVNode(IconButton, {
      class: "icon-button",
      icon: "keyboard_arrow_right",
      iconColor: "color-dark2",
      useBorder: false,
      disabled: _unref(disabledNextBtn),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleCurrentChange('next')))
    }, null, 8, ["disabled"])
  ], 512)), [
    [_vShow, _unref(displayPagination)]
  ])
}
}

})